import { Component, createRef } from 'react'
import styled, { ThemeProvider } from 'styled-components'

import styledTheme from '../../../styles/theme'
import { trackAdventureViewed } from '../../../analytics/map'

import { MarkerPopupWrapper } from '../styled'
import WithSelectEscape from '../../SelectEscape/WithSelectEscape'
import AdventureCard from '../../../pages/listing/Adventures/AdventureCard'

const CalloutWrapper = styled.div`
  position: relative;
  height: 0;
  width: 0;
  font-family:
    'GT Walsheim Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;

  transition: transform 300ms ease-out;

  ${({ x, y }) => `
    transform: translate(${x}px, ${y}px);
  `}

  ${({ open }) =>
    open &&
    `
    z-index: 1;
  `}
`

export default class AdventureCallout extends Component {
  constructor() {
    super()
    this.state = {
      transform: {
        x: 0,
        y: 0,
      },
    }
    this.isDragging = false
    this.calloutRef = createRef()
    this.analyticsTracked = false
  }

  componentDidMount() {
    const { transform } = this.props

    if (transform) {
      setTimeout(() => this.setState({ transform }), 0)
    }
  }

  componentDidUpdate() {
    const { open, mapContainerRef, adventure, source } = this.props

    if (adventure?.id && open && this.analyticsTracked !== true) {
      trackAdventureViewed({
        adventureId: adventure.id,
        source,
      })
      this.analyticsTracked = true
    }

    if (open && mapContainerRef.current) {
      mapContainerRef.current.addEventListener(
        'mousedown',
        this.handleMouseDown,
      )
      mapContainerRef.current.addEventListener(
        'mousemove',
        this.handleMouseMove,
      )
      mapContainerRef.current.addEventListener('mouseup', this.handleMouseUp)
      mapContainerRef.current.addEventListener('click', this.handleMouseUp)
    } else {
      this.removeListeners()
    }
  }

  componentWillUnmount() {
    this.removeListeners()
  }

  removeListeners = () => {
    const { mapContainerRef } = this.props
    if (mapContainerRef.current) {
      mapContainerRef.current.removeEventListener(
        'mousedown',
        this.handleMouseDown,
      )
      mapContainerRef.current.removeEventListener(
        'mousemove',
        this.handleMouseMove,
      )
      mapContainerRef.current.removeEventListener('mouseup', this.handleMouseUp)
      mapContainerRef.current.removeEventListener('click', this.handleMouseUp)
    }
  }

  handleMouseDown = () => {
    this.isDragging = false
  }

  handleMouseUp = (e) => {
    if (!this.isDragging) {
      const { onClose } = this.props
      if (!this.calloutRef.current.contains(e.target)) {
        onClose()
      }
    }
  }

  handleMouseMove = () => {
    this.isDragging = true
  }

  render() {
    const { transform } = this.state
    const {
      adventure,
      children,
      open,
      bookingAdventuresIndex,
      bucketListItemsIndex,
      onAddedToBucketList,
      onRemovedFromBucketList,
      onPopupInteractionStart,
      onPopupInteractionEnd,
      notBucketListable,
    } = this.props

    if (!adventure || !adventure?.id) {
      return null
    }

    return (
      <CalloutWrapper ref={this.calloutRef} {...transform} open={open}>
        <ThemeProvider theme={styledTheme}>
          <div>
            {children}
            <MarkerPopupWrapper
              open={open}
              onMouseEnter={onPopupInteractionStart}
              onMouseLeave={onPopupInteractionEnd}
              onTouchStart={onPopupInteractionStart}
              onTouchEnd={onPopupInteractionEnd}
              onTouchCancel={onPopupInteractionEnd}
            >
              {notBucketListable ? (
                <AdventureCard {...adventure} embedded compactCard />
              ) : (
                <WithSelectEscape
                  itemId={adventure.id}
                  itemType="Adventure"
                  bookingAdventuresIndex={bookingAdventuresIndex}
                  bucketListItemsIndex={bucketListItemsIndex}
                  onAddedToBucketList={onAddedToBucketList}
                  onRemovedFromBucketList={onRemovedFromBucketList}
                >
                  <AdventureCard {...adventure} embedded compactCard />
                </WithSelectEscape>
              )}
            </MarkerPopupWrapper>
          </div>
        </ThemeProvider>
      </CalloutWrapper>
    )
  }
}
